import { render, staticRenderFns } from "./bestDeals.vue?vue&type=template&id=01b778dc&scoped=true&"
import script from "./bestDeals.vue?vue&type=script&lang=js&"
export * from "./bestDeals.vue?vue&type=script&lang=js&"
import style0 from "./bestDeals.vue?vue&type=style&index=0&id=01b778dc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01b778dc",
  null
  
)

export default component.exports